import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      timer: null
    }
  },

  methods: {
    debounce(fn, delay) {
      let delays = delay || 500;
      return () => {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.timer = null;
          fn.apply(this)
        }, delays);
      };
    },

    collapse() {
      this.setCollapse(true)
      // console.log("TCL: collapse -> this.setCollapse", this)
    },

    setLeftCollapse() {
      this.debounce(this.collapse, 1500)()
    },

    ...mapMutations(["setCollapse", "changeCollapse"])
  }
}